import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class AddItemRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'AddItemRequest';
        this.Config   = new AppConfig();
        this.payload  = null;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload  = payload;
        this.call(this.Config.api.requests.addItem, payload);
    }

    //Parse successful response
    onSuccess() {
        let data = this.response.data;
        this.updateState(data);
    }

    //Dispatch actions to update redux state
    updateState(data) {
        this.dispatch(Actions.setCartRequest(getCartRequest(data.itemsArr)));
        this.dispatch(Actions.setCart(data));
    }
}

function getCartRequest(data) {
    let res = {};
    for (let key in data){
        res[key] = {
            quantity: 1,
            payments: 1,
            delivery_method_id: -1,
            branch_id: -1,
        }
    }

    return res;
}


export default AddItemRequest;